import { createContext, useContext } from "react";
/**
 * Create a context with a nullable default value
 * @param defaultValue
 * @returns Context whose value can be null
 */ export function createNullableContext(defaultValue) {
    return /*#__PURE__*/ createContext(defaultValue ?? null);
}
/**
 * Hook for using a nullable context that throws if the context is null
 * @param context
 * @returns Non-null context value
 */ export function useNullSafeContext(context) {
    const value = useContext(context);
    if (value === null) {
        throw new Error("Context must be not null");
    }
    return value;
}
